/* eslint-disable no-undef */
'use strict';

$(document).ready(function () {
    var $productSlides = $('.product-enhanced-grid-carousel').find('.product');
    for (var i = 0; i < $productSlides.length; i++) {
        if ($($productSlides[i]).data('pid') === null) {
            $($productSlides[i]).parent().remove();
        }
    }
});

$('.product-enhanced-grid .product-grid').on('click', function () {
    var componentHeader = $('.product-enhanced-grid .carousel-heading h2')[0].innerText;
    var position = Array.from($('.product-enhanced-grid .product-grid')).indexOf(this) + 1;
    _satellite.track('product-interaction', {
        component: 'product-grid',
        id: componentHeader,
        position: position
    });
});

$('.product-enhanced-grid-multi .product-grid, .multi-tab .product-carousel-slide').on('click', function () {
    var component;
    var position;
    var componentHeader;
    if ($(this).closest('.product-enhanced-grid-multi').length > 0) {
        component = 'product-grid';
        position = Array.from($(this).closest('.tab-pane').find('.product-grid')).indexOf(this) + 1;
    } else {
        component = 'product-carousel';
        position = Array.from($(this).closest('.tab-pane').find('.product-carousel-slide:not(.slick-cloned)')).indexOf(this) + 1;
    }
    if ($(this).closest('.recommendations').find('h2.carousel-heading').length > 0) {
        componentHeader = $(this).closest('.recommendations').find('h2.carousel-heading')[0].innerText;
    } else {
        componentHeader = '';
    }

    var tab = 'tab: ' + $(this).closest('.recommendations').find('.multitablink').find('.ctaButton.active')[0].innerText;
    _satellite.track('product-interaction', {
        component: {
            id: 'product-interaction',
            type: component, // see sample value below
            text: componentHeader,
            position: position, // integer
            detail: tab
        }
    });
});
